<template>
  <div class="page flex flex-col w-1600px m-auto bg-white" style="position: relative;">
   <lists v-if="page === 'lists'" ref="lists" @listClick="listClick" />
   <el-tabs v-model="activeName" type="card"  v-if="page === 'detail'">
    <el-tab-pane label="讨论内容" name="first">
      <detail
      v-if="page === 'detail'"
      :data="discussData"
      @back="page = 'lists'"
    />
    </el-tab-pane>
    <el-tab-pane :label="'代码改动'+'('+diffs.length+')'" name="second" >
      <el-collapse v-model="activeNames"  class="page px-0.2rem">
        <el-collapse-item :title="item.OldPath" :name="index" v-for="(item , index) in diffs" :key="index">
              <diff :data="item" ></diff>
        </el-collapse-item>
      
      </el-collapse>
    
    </el-tab-pane>
     
  </el-tabs>

    <Footer />
  </div>
</template>

<script>
import lists from './lists.vue'
import detail from './detail.vue'
import Footer from '@/components/layout/footer.vue'
import diff from './filediff.vue'

export default {
  components: { lists, detail , Footer , diff},
  props: { data: {} },
  computed: {
        diffsinfo() {
          return this.diffs
        }
      },
  watch: {
    diffsinfo: {
      handler(newVal) {
        this.activeNames = []
        for(let i = 0 ; i < newVal.length ; i++){
           this.activeNames.push(i)
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      page: 'lists',
      activeName: 'first',
      discussData: {},
      activeNames: [],
   
      diffs:[
            {
                "AMode": "100644",
                "BMode": "100644",
                "DeletedFile": false,
                "Diff": "@@ -32,7 +32,7 @@ tasks:\n ### 当前模型的贡献者未提供更加详细的模型介绍。模型文件和权重，可浏览“模型文件”页面获取。\n #### 您可以通过如下git clone命令，或者ModelScope SDK来下载模型\n \n-SDK下载\n+SDK下载我也不知道下载什么\n ```bash\n #安装ModelScope\n pip install modelscope\n",
                "NewFile": false,
                "NewPath": "README.md",
                "OldPath": "README.md",
                "RenamedFile": false
            },
            {
                "AMode": "100644",
                "BMode": "100644",
                "DeletedFile": false,
                "Diff": "@@ -1 +1,2 @@\n-十大大苏打钱钱钱钱钱\n\\ No newline at end of file\n+十大大苏打钱钱钱钱钱\n+88963\n\\ No newline at end of file\n",
                "NewFile": false,
                "NewPath": "测试.txt",
                "OldPath": "测试.txt",
                "RenamedFile": false
            },
            {
                "AMode": "100644",
                "BMode": "100644",
                "DeletedFile": false,
                "Diff": "@@ -1,38 +1,6 @@\n ---\n-frameworks:\n-- Pytorch\n-license: Apache License 2.0\n-tasks:\n-- image-object-detection\n \n-#model-type:\n-##如 gpt、phi、llama、chatglm、baichuan 等\n-#- gpt\n-\n-#domain:\n-##如 nlp、cv、audio、multi-modal\n-#- nlp\n-\n-#language:\n-##语言代码列表 https://help.aliyun.com/document_detail/215387.html?spm=a2c4g.11186623.0.0.9f8d7467kni6Aa\n-#- cn \n-\n-#metrics:\n-##如 CIDEr、Blue、ROUGE 等\n-#- CIDEr\n-\n-#tags:\n-##各种自定义，包括 pretrained、fine-tuned、instruction-tuned、RL-tuned 等训练方法和其他\n-#- pretrained\n-\n-#tools:\n-##如 vllm、fastchat、llamacpp、AdaSeq 等\n-#- vllm\n ---\n-### 当前模型的贡献者未提供更加详细的模型介绍。模型文件和权重，可浏览“模型文件”页面获取。\n-#### 您可以通过如下git clone命令，或者ModelScope SDK来下载模型\n-\n-SDK下载我也不知道下载什么\n ```bash\n #安装ModelScope\n pip install modelscope\n",
                "NewFile": false,
                "NewPath": "README.md",
                "OldPath": "README.md",
                "RenamedFile": false
            },
            {
                "AMode": "0",
                "BMode": "100644",
                "DeletedFile": false,
                "Diff": "Binary files /dev/null and b/node-v20.10.0-x64.msi differ\n",
                "NewFile": true,
                "NewPath": "node-v20.10.0-x64.msi",
                "OldPath": "node-v20.10.0-x64.msi",
                "RenamedFile": false
            },
            {
                "AMode": "100644",
                "BMode": "100644",
                "DeletedFile": false,
                "Diff": "@@ -36,6 +36,7 @@ SDK下载\n ```bash\n #安装ModelScope\n pip install modelscope\n+的撒大苏打实打实的撒大苏打是\n ```\n ```python\n #SDK模型下载\n",
                "NewFile": false,
                "NewPath": "README.md",
                "OldPath": "README.md",
                "RenamedFile": false
            }
        ]
    }
  },
  created() {},
  mounted() {},
  methods: {
    listClick(data) {
      this.discussData = data
      this.page = 'detail'
    }
  }
}
</script>
<style lang="scss" scoped>

.page {
  min-height: calc(100vh - 290px);
  margin-top: 10px;
}
::v-deep{
  .el-tabs__item{
    text-align: center !important;
    margin: 0 !important;
  }
}

</style>
